import { useContext } from "react";
import type { RootStoreInstance } from "./types";
import { StoreContext } from "./StoreProvider";

/**
 * Hook to access the stores from within components.
 * Must be used within a StoreProvider, otherwise throws an error.
 *
 * @returns The root store instance
 * @throws Error if used outside of StoreProvider
 */
export function useStores(): RootStoreInstance {
  const context = useContext(StoreContext);

  if (context === undefined) {
    throw new Error("useStores must be used within StoreProvider");
  }

  return context;
}

/**
 * The stores when a StoreProvider is mounted, else `null`. For components that
 * also render on surfaces without one (the public share page, the chat's
 * document preview in isolation) and merely lose a signed-in affordance there.
 */
export function useOptionalStores(): RootStoreInstance | null {
  return useContext(StoreContext) ?? null;
}
